export default {
  data: function () {
    return {
      titleApp: this.getAppName(),
    };
  },
  computed: {
    currentLangue() {
      if (this.$store.getters['app/config'].langues.length > 0) {
        //Liste des langues provenant de la BDD
        if (this.$store.getters['auth/user']) {
          return window._.find(
            this.$store.getters['app/config'].langues,
            (langue) =>
              langue.code === this.$store.getters['auth/user'].langue_code
          );
        } else if (this.$store.getters['app/societe']) {
          return window._.find(
            this.$store.getters['app/config'].langues,
            (langue) =>
              langue.code === this.$store.getters['app/societe'].langue.code
          );
        }
      }

      //Langue par défaut du FONT
      return this.$store.getters['app/config'].defaultLangue;
    },
  },
  methods: {
    formatWithCurrency(value, symbole) {
      return this.$options.filters.currency(value, {
        symbol: symbole,
        thousandsSeparator: ' ',
        fractionCount: 2,
        fractionSeparator: ',',
        symbolPosition: 'back',
        symbolSpacing: true,
      });
    },
    getAppName() {
      let config = this.$store.getters['app/config'];
      return config.appName;
    },

    getCurrency() {
      if (this.$store.getters['app/societe']) {
        return this.$store.getters['app/societe'].devise;
      }

      return null;
    },
    getCurrencySymbole() {
      /*let config = store.getters['app/config'];
      if (config.appCurrencySymbole !== undefined) {
        return config.appCurrencySymbole;
      }
*/
      return null;
    },
    onChangeLangue() {
      //this.$store.dispatch('app/setConfig', { appLangue: langue });
      this.$root.$i18n.locale = this.currentLangue.code;
    },
  },
};
